import { createContext, useContext } from 'react'

export type Role = 'teacher' | 'classTeacher'

interface RoleContextValue {
  role: Role
}

const RoleContext = createContext<RoleContextValue | null>(null)

export const RoleProvider = RoleContext.Provider

export function useRole() {
  const ctx = useContext(RoleContext)
  if (!ctx) throw new Error('useRole must be used within a RoleProvider')
  return ctx
}
